var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("学生名称："+_vm._s(_vm.studentsname))]),_vm._v(" "),_c('h2',[_vm._v("学生地址："+_vm._s(_vm.studentsaddress))]),_vm._v(" "),_c('button',{on:{"click":_vm.showname}},[_vm._v("点击")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ff9b158","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/study/study3/students.vue
// module id = null
// module chunks = 